import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Badge, IconButton } from "@mui/material";
import Iconify from "../../../components/iconify";
import { CART_STORAGE_KEY } from "../../../sections/@dashboard/shop/shopUtils";

const readCartCount = () => {
  try {
    const stored = localStorage.getItem(CART_STORAGE_KEY);
    if (!stored) return 0;
    const items = JSON.parse(stored);
    if (!Array.isArray(items)) return 0;
    return items.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
  } catch {
    return 0;
  }
};

export default function ShopCartHeaderButton() {
  const navigate = useNavigate();
  const [cartCount, setCartCount] = useState(readCartCount);

  const refresh = useCallback(() => {
    setCartCount(readCartCount());
  }, []);

  useEffect(() => {
    // Listen for cart updates dispatched from ShopPage
    window.addEventListener("ma-cart-updated", refresh);
    return () => window.removeEventListener("ma-cart-updated", refresh);
  }, [refresh]);

  const handleClick = () => {
    navigate("/dashboard/shop?openCart=1");
  };

  return (
    <IconButton
      color="default"
      onClick={handleClick}
      sx={{ width: 40, height: 40 }}
      aria-label="Warenkorb"
    >
      <Badge badgeContent={cartCount} color="error" overlap="circular" max={99} showZero={false}>
        <Iconify icon="eva:shopping-cart-fill" />
      </Badge>
    </IconButton>
  );
}
